import { TradingViewWidget } from 'src/components/TradingViewWidget'
import dynamic from 'next/dynamic'
import { useState, useEffect } from 'react'
import { ButtonGroup } from 'src/components/ButtonGroup'
import { ButtonGroupItem } from 'src/components/ButtonGroup/components/ButtonGroupItem'
import styles from './styles.module.scss'

const CoinChart = dynamic(() => import('src/components/CoinChart'), {
  ssr: false,
})

const COIN360_CHART = 'coin360'
const TRADINGVIEW_CHART = 'tradingView'

export const ChartsTab = ({ coin }) => {
  const [chart, setChart] = useState(COIN360_CHART)

  return (
    <>
      <div className={styles.selector}>
        <h2 className={styles.title}>{coin.name} Charts</h2>
        <ButtonGroup onChange={setChart} value={chart}>
          <ButtonGroupItem value={COIN360_CHART}>COIN360</ButtonGroupItem>
          <ButtonGroupItem value={TRADINGVIEW_CHART}>
            TradingView
          </ButtonGroupItem>
        </ButtonGroup>
      </div>
      <div className={styles.chart}>
        {chart === COIN360_CHART && (
          <CoinChart
            change={coin.change}
            coin={coin.name.toLowerCase()}
            height={462}
            isShare={false}
            price={coin.price}
            slug={coin.slug}
            symbol={coin.code}
            width='100%'
          />
        )}
        {chart === TRADINGVIEW_CHART && (
          <TradingViewWidget symbol={coin.code} />
        )}
      </div>
    </>
  )
}

export default ChartsTab
